import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import { useResetRecoilState, useRecoilState, useRecoilValue } from "recoil";
import { selectedFocusAreaAtom } from "../map/selectedRegionAtoms";
import { useResetLayerDefsAtom } from "../layers/recoil";
import {
  focusAreaLayers,
  focusAreaLayerIdSelector,
} from "../map/focusAreaLayerAtoms.js"

import SidebarDropdown from "./SidebarDropdown.jsx"
import RadiusSlider from "./sliders/RadiusSlider";

const StyledBox = styled(Box)(() => ({
  backgroundColor: "#1b2021",
}));

const focusAreaLayerDropdownOptions = focusAreaLayers.map((layer) => {
  return {
    value: layer.id,
    label: layer.label,
  }
})

const SidebarFocusAreaControls = ({ isMobile }) => {
  const resetSelectedFocusArea = useResetRecoilState(selectedFocusAreaAtom);
  const selectedFocusArea = useRecoilValue(selectedFocusAreaAtom);
  const resetLayerDefsAtom = useResetLayerDefsAtom();
  const [focusAreaLayerId, setFocusAreaLayerId] = useRecoilState(focusAreaLayerIdSelector);

  const clearFocusArea = () => {
    resetSelectedFocusArea();
    resetLayerDefsAtom();
    setFocusAreaLayerId(focusAreaLayerId)
  };

  const renderFocusAreaName = () => {
    if (!selectedFocusArea) {
      return "Select a high street on the map to begin exploring."
    }
    return selectedFocusArea?.properties["name"]
  }

  return (
    <>
      <StyledBox sx={{
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        rowGap: "20px",
        width: "100%",
        ml: "auto",
        mr: "auto",
      }}>
        <SidebarDropdown
          id="focus-area-layer-dropdown"
          label="Focus area layer"
          options={focusAreaLayerDropdownOptions}
          defaultValue={focusAreaLayerId}
          disabled={!!selectedFocusArea}
          onChange={setFocusAreaLayerId}
          sx={{ height: "50px" }} />
        <StyledBox className="focus-area-details" sx={{
          display: "flex",
          justifyContent: "space-between",
          columnGap: "1rem",
        }}>
          <Typography variant="h5" sx={{ flexGrow: 1 }}>
            {renderFocusAreaName()}
          </Typography>
          <Button
            disabled={!selectedFocusArea}
            target="_blank"
            rel="noreferrer"
            variant="outlined"
            startIcon={<ClearIcon />}
            onClick={clearFocusArea}
            sx={{
              flexShrink: 0,
              width: "150px",
              height: "50px",
            }}>
            Clear Selection
          </Button>
        </StyledBox>
        <RadiusSlider isMobile={isMobile} sx={{
          pl: "10px",
          pb: "15px",
        }} />
      </StyledBox>
    </>
  )
};

export default SidebarFocusAreaControls;